(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

(function () {

  const hamburger  = document.getElementById('header-mobile-toggle');
  const mobileNav  = document.getElementById('mobile-nav');
  const overlay    = document.getElementById('mobile-overlay');
  const closeBtn   = document.getElementById('mobile-nav-close');

  function openMenu() {
    mobileNav.classList.add('is-open');
    overlay.classList.add('is-visible');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileNav.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  hamburger && hamburger.addEventListener('click', function () {
    mobileNav.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay  && overlay.addEventListener('click', closeMenu);

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // ── Mobile sub-menu toggles ──
  document.querySelectorAll('.mobile-nav__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub      = btn.nextElementSibling;
      var isOpen   = btn.getAttribute('aria-expanded') === 'true';

      // Collapse all other open submenus
      document.querySelectorAll('.mobile-nav__toggle').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var otherSub = other.nextElementSibling;
          if (otherSub) otherSub.classList.remove('is-open');
        }
      });

      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      sub && sub.classList.toggle('is-open', !isOpen);
    });
  });

})();


  } catch(e) { console.error(e); }
})();
})();
